export default "__VITE_ASSET__5fd53049__"